import { renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _renderSlot(_ctx.$slots, "default", {
    pageFilled: _ctx.onPageIsFull,
    pageStartIndexes: _ctx.startIndexes,
    pageElements: _ctx.elementsList,
    grapSlottedElements: _ctx.convertToElementsArray
  })
}